exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.exporter[data-v-328e845e] {\n  display: grid;\n  gap: 12px;\n}\n.btn[data-v-328e845e] {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  background: #111;\n  color: #fff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Keep A4 width for WYSIWYG */\n.print-container[data-v-328e845e] {\n  width: 210mm;\n  background: #fff;\n  padding: 0;\n  display: none;\n}\n.show-print-container[data-v-328e845e] {\n  display: block;\n}\n\n/* Optional page break helper for content inside SummaryAttendancesMonth */\n.page-break[data-v-328e845e] {\n  break-after: page;\n}\n", ""]);

// exports
